/**
 * Texts for Sam's review article
 */
export const samReviewText = {
    title: 'Sam e Sofia-Stevie - CamAPS FX',
    titleMeta: 'Leia a história de Sam e Sofia-Stevie sobre o CamAPS FX',
    descriptionMeta: 'O CamAPS FX transformou a vida de Sam e Sofia-Stevie, permitindo que Sam relaxasse pela primeira vez desde o diagnóstico.',
    keywords:
        'história camaps Sam e Sofia-Stevie, história camaps fx Sam e Sofia-Stevie, ' +
        '',
    localeMeta: 'pt_PT',

    imageTitle: 'Sam e Sofia-Stevie',
    shortIntroAndBody:
        '<h2>Sinto que, pela primeira vez desde o diagnóstico, posso relaxar</h2>' +
        '<p>' +
        '        Confio plenamente na aplicação CamAPS FX e sinto que, pela primeira vez desde o diagnóstico, posso relaxar. Sem dúvida, o ' +
        '        tempo que Sofia-Stevie passa dentro do seu intervalo-alvo de glicose melhorou. ' +
        '</p>',
    body: 
        '<h2>Sinto que, pela primeira vez desde o diagnóstico, posso relaxar</h2> ' +
        '<p> ' +
        '    <strong> ' +
        '        Nos últimos dois anos, Sam, mãe de Sofia-Stevie (5 anos), ' +
        '        enfrentou a curva de aprendizagem extremamente íngreme que qualquer progenitor de uma criança ' +
        '        com diabetes tipo 1 tem de percorrer. Depois de um turbilhão de picadas no dedo, ' +
        '        injeções e sensores, descobriu a aplicação CamAPS FX ' +
        '        e o sistema de circuito fechado híbrido, e já não prescinde deles. ' +
        '    </strong> ' +
        '</p> ' +
        '<p> ' +
        '    Num verão quente, a sede excessiva não seria nada de extraordinário ' +
        '    numa criança pequena. No entanto, Sam e a sua mãe seguiram a intuição ' +
        '    de que poderia ser algo mais e começaram a investigar se havia motivo ' +
        '    de preocupação, o que acabou por conduzir ao diagnóstico de ' +
        '    diabetes tipo 1 de Sofia-Stevie. ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '        “O diagnóstico mudou tudo para sempre. Lembro-me das primeiras semanas ' +
        '        como se tivesse sido ontem. Quase de um dia para o outro, senti que precisava ' +
        '        de ser uma especialista em diabetes para cuidar da melhor forma da minha menina. ' +
        '        Ela é a minha prioridade absoluta, por isso simplesmente fiz o que tinha de fazer, e sinto-me realmente orgulhosa ' +
        '        de mim e da minha mãe por o termos feito – ela tem estado connosco nesta jornada ' +
        '        desde o início.” ' +
        '    </i> ' +
        '</p> ' +
        '<h3> ' +
        '    Uma curva de aprendizagem íngreme ' +
        '</h3> ' +
        '<p> ' +
        '    Como a maioria dos progenitores de uma criança com diagnóstico recente de diabetes tipo 1, ' +
        '    Sam tornou-se rapidamente especialista em picadas no dedo, administração de insulina basal e em bólus ' +
        '    e no que fazer quando a filha estava hipoglicémica. ' +
        '    Injetar o próprio filho seria um desafio para qualquer progenitor, mas especialmente ' +
        '    para Sam, que também teve de superar o medo das agulhas. ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '        “A equipa clínica do Addenbrooke’s Hospital foi extraordinária a ' +
        '        ajudar-me a ultrapassar alguns grandes desafios naqueles primeiros dias, ' +
        '        especialmente Adam Dawes, enfermeiro especialista clínico no hospital. ' +
        '        Não penso que estaríamos onde estamos hoje sem o apoio de ' +
        '        Adam e da equipa clínica.” ' +
        '    </i> ' +
        '</p> ' +
        '<p> ' +
        '    Nos primeiros meses após o diagnóstico de Sofia-Stevie, as picadas no dedo eram ' +
        '    uma ocorrência regular para compreender os níveis de glicose ao longo do dia. ' +
        '    Sam também tinha de programar alarmes à noite para poder verificar os níveis de ' +
        '    glicose da filha. Se os níveis de Sofia-Stevie estavam altos ou baixos, Sam tinha de ' +
        '    administrar uma dose de correção e depois esperar até que os níveis se movessem na ' +
        '    direção certa antes de voltar a dormir, um processo esgotante ' +
        '    para ambas, todas as noites. ' +
        '</p> ' +
        '<p> ' +
        '    Eventualmente, Sofia-Stevie recebeu um sistema de monitorização contínua da glicose (CGM) para ' +
        '    apoiar os seus cuidados. Um CGM é um pequeno dispositivo com um sensor usado mesmo por baixo ' +
        '    da pele para medir os níveis de glicose de forma contínua. Sam viu o CGM como um passo ' +
        '    na direção certa, sobretudo porque o dispositivo significava que já não tinha ' +
        '    de programar alarmes à noite – o dispositivo alertá-la-ia automaticamente se os níveis de ' +
        '    glicose de Sofia-Stevie estivessem fora do intervalo. O CGM também sincroniza com ' +
        '    o telemóvel de Sam, para que ela possa verificar os níveis de glicose de Sofia-Stevie na ' +
        '    escola, e também ajuda os professores nos cuidados ao longo do dia. ' +
        '</p> ' +
        '<p> ' +
        '    Mas em janeiro de 2020 Sam foi apresentada à aplicação CamAPS FX ' +
        '    e, desde então, não olhou para trás. ' +
        '</p> ' +
        '<h3> ' +
        '    Encontrar a liberdade ' +
        '</h3> ' +
        '<p> ' +
        '    A aplicação CamAPS FX foi desenvolvida para imitar as funções essenciais de um ' +
        '    pâncreas saudável, a chamada abordagem de circuito fechado híbrido ao tratamento. ' +
        '    A aplicação comunica de forma autónoma com o CGM e a bomba de insulina do doente ' +
        '    e utiliza um algoritmo complexo para calcular e administrar automaticamente ' +
        '    a dose ótima de insulina a cada 8-12 minutos. ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '        “Nunca tinha ouvido falar do sistema de circuito fechado híbrido, ' +
        '        nem da aplicação CamAPS FX. Não sabia como funcionava, mas quando ' +
        '        o Adam sugeriu que poderia ser benéfico para nós, lançámo-nos de imediato. ' +
        '        Nessa altura já tinha aprendido tanto sobre diabetes que aprender sobre o ' +
        '        circuito fechado híbrido pareceu um passeio no parque.” ' +
        '    </i> ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '        “Confio plenamente na aplicação CamAPS FX e sinto que, pela primeira vez desde o diagnóstico, posso relaxar. Sem dúvida, o ' +
        '        tempo que Sofia-Stevie passa dentro do seu intervalo-alvo de glicose melhorou. ' +
        '        É muito mais fácil controlar os seus níveis agora e foi um ' +
        '        enorme peso que saiu dos meus ombros. Também é menos exigente para ' +
        '        os professores e muito menos preocupação para mim. Posso verificá-la ' +
        '        à distância se quiser, mas também tenho a tranquilidade de receber ' +
        '        mensagens de texto automáticas se ela estiver a subir ou a descer.” ' +
        '    </i> ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '        “Não se diria que ela é diferente de qualquer um dos seus ' +
        '        colegas, e isso deve-se à aplicação CamAPS FX.” ' +
        '    </i> ' +
        '</p> ' +
        '<p> ' +
        '    Sam não está sozinha nas suas observações sobre a mudança que a aplicação CamAPS FX teve ' +
        '    nela e na filha. A investigação demonstrou que a aplicação melhora ' +
        '    o sono dos adolescentes e proporciona a sensação de acordar a sentir-se normal, ' +
        '    o que facilita um melhor controlo da diabetes durante o dia, ajudando ' +
        '    a concentração e o bem-estar na escola. Além disso, os progenitores de crianças ' +
        '    que utilizam a aplicação demonstraram sentir-se menos ansiosos em relação à diabetes ' +
        '    dos filhos e, em consequência, mais capazes de lhes dar maior ' +
        '    liberdade, como brincar com amigos, ir a visitas de estudo e ' +
        '    participar em pijama parties. ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '        “Faz todo o sentido que crianças da idade de Sofia-Stevie tenham ' +
        '        o circuito fechado, porque o corpo está constantemente a mudar a forma como ' +
        '        responde à insulina. É extremamente difícil para um ' +
        '        progenitor acompanhar isso sem hiperglicemias e hipoglicemias significativas, ' +
        '        ao passo que a aplicação aprende e adapta-se de imediato. É benéfico para ' +
        '        a gestão a longo prazo da condição da criança e para a liberdade dos ' +
        '        progenitores, para que possam dormir à noite.” ' +
        '    </i> ' +
        '</p> ' +
        '<h3> ' +
        '    Nunca prescindiria da aplicação ' +
        '</h3> ' +
        '<p> ' +
        '    <i> ' +
        '        “Nunca prescindiria da aplicação. É algo que está a cuidar de ' +
        '        si, para que não tenha de se preocupar. A quem esteja a considerá-la, avance. ' +
        '        É realmente transformadora e, depois de a ter, não vai querer voltar atrás nem prescindir ' +
        '        dela. Acredito plenamente que é tão benéfica para ' +
        '        os progenitores como para a criança.” ' +
        '    </i> ' +
        '</p>'

};

/**
 * Texts for Roger's review article
 */
export const rogerReviewText = {
    title: 'Roger - CamAPS FX',
    titleMeta: 'Leia a história de Roger sobre o CamAPS FX',
    descriptionMeta: 'Roger comenta que o CamAPS FX pode ser utilizado por qualquer pessoa e em qualquer idade.',
    keywords:
        'história camaps Roger, história camaps fx Roger, ' +
        '',
    localeMeta: 'pt_PT',

    imageTitle: 'Roger',
    shortIntroAndBody:
        '<h2>Se eu consigo, qualquer pessoa consegue</h2>' +
        '<p>' +
        '    É incrível o quanto o tratamento mudou desde que fui diagnosticado. ' +
        '    Sinto verdadeiramente que passei do deserto para o mundo digital. ' +
        '    Para quem esteja a considerar a aplicação CamAPS FX, o meu conselho é muito simples: avance. ' +
        '    É realmente transformadora; e, se eu consigo, qualquer pessoa consegue.' +
        '</p>',
    body:
        '<h2>Se eu consigo, qualquer pessoa consegue</h2> ' +
        '<p> ' +
        '    <strong> ' +
        '        Diagnosticado com diabetes tipo 1 já em adulto, Roger, diretor de escola reformado, ' +
        '       de 69 anos, passou os últimos 39 anos em busca de uma maior compreensão da ' +
        '       sua condição. Viveu em primeira mão a transformação nos cuidados da diabetes ' +
        '       durante este período, desde seringas de vidro e agulhas grossas esterilizadas numa panela de ' +
        '       água a ferver até à aplicação CamAPS FX e ao sistema de circuito fechado híbrido, ' +
        '       de que já não prescinde.   ' +
        '    </strong> ' +
        '</p> ' +
        '<p> ' +
        '    Hoje, a diabetes tipo 1 é frequentemente diagnosticada na infância, mas para Roger só aos ' +
        '   30 anos é que os sintomas se tornaram evidentes. Tanto o tio como a sogra de Roger tinham ' +
        '   sido diagnosticados com diabetes tipo 1, pelo que ele já estava familiarizado com os sintomas. ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '        “Lembro-me nitidamente de que tinha acabado de tomar o pequeno-almoço e estava no jardim a fazer ' +
        '       uns trabalhos. Entrei em casa e estava extremamente sedento. Bebi um pint de ' +
        '       sumo de uma só vez e eu e a minha mulher olhámos um para o outro e ao mesmo ' +
        '       tempo dissemos ‘diabetes’. O meu médico de família precisou de ser convencido, mas fui referenciado para exames ' +
        '       que confirmaram que tinha diabetes.” ' +
        '    </i> ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '        “Na altura, o conhecimento e o tratamento da diabetes eram muito limitados em comparação com agora. ' +
        '           Deram-me simplesmente algumas seringas de vidro, disseram-me como esterilizar as agulhas em ' +
        '           água a ferver numa panela e deram-me uma quantidade-alvo de insulina. ' +
        '           Felizmente, a minha sogra emprestou-me o manual da British Diabetic Association e ' +
        '           lembro-me de estar sentado na cozinha com a minha mulher a manter o livro aberto ' +
        '           enquanto eu aprendia sozinho a fazer as injeções.” ' +
        '    </i> ' +
        '</p> ' +
        '<h3> ' +
        '    Em busca de um melhor controlo  ' +
        '</h3> ' +
        '<p> ' +
        '    Durante esses primeiros anos, Roger beneficiou muito dos recursos da British Diabetic ' +
        '   Association (hoje conhecida como Diabetes UK), por exemplo ao aprender sobre a necessidade de ' +
        '   administrar mais insulina quando estava doente, o que até então desconhecia. ' +
        '   Roger estava a gerir bem a sua condição, mas depois os seus níveis de glicose tornaram-se mais desafiantes ' +
        '   e foi referenciado para o curso DAFNE (dose adjustment for normal eating) para aprender ' +
        '   a ajustar a insulina à alimentação e ao estilo de vida. No entanto, Roger continuava a ter ' +
        '   episódios graves de hipoglicemia.  ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '        “Estava a cuidar do meu neto e a jogar futebol com ele no jardim. ' +
        '       O meu genro veio buscá-lo e de repente disse: ‘Roger, precisas de ir beber ' +
        '       um sumo.’ De facto, fiz uma picada no dedo e estava cerca de 2 mmol/l, ' +
        '       portanto bem abaixo do que deveria estar. Era para eu cuidar do meu neto ' +
        '       no dia seguinte, mas fizeram outros arranjos. Não acharam que eu estivesse suficientemente bem ' +
        '       para cuidar dele e isso devastou-me; soube que já chega.” ' +
        '    </i> ' +
        '</p> ' +
        '<p> ' +
        '    Depois de partilhar esta história com o seu médico consultor, foi referenciado para um ' +
        '      projeto de investigação sobre episódios de hipoglicemia inexplicados e começou a utilizar ' +
        '       uma bomba de insulina. Imediatamente, a bomba ajudou a melhorar os níveis de glicose de Roger. ' +
        '</p> ' +
        '<p> ' +
        '    Tendo beneficiado tanto do primeiro projeto de investigação, quando Roger teve a ' +
        '   oportunidade de participar noutro, não hesitou e começou a utilizar ' +
        '   a aplicação CamAPS FX em outubro de 2019. ' +
        '</p> ' +
        '<p> ' +
        '    A aplicação CamAPS FX foi desenvolvida para imitar as funções essenciais de um pâncreas saudável, ' +
        '       a chamada abordagem de circuito fechado híbrido ao tratamento. A aplicação comunica de forma autónoma ' +
        '       com o monitor contínuo de glicose e a bomba de insulina do doente e utiliza um algoritmo complexo ' +
        '       para calcular e administrar automaticamente a dose ótima de insulina a cada 8-12 minutos.   ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '        “Confesso que nunca tinha ouvido falar do sistema de circuito fechado híbrido, ' +
        '       mas quando os meus dois filhos souberam que eu ia gerir a diabetes a partir de um smartphone ' +
        '       riram-se à gargalhada! Antes da investigação, o meu conhecimento de ' +
        '       utilização de um telemóvel resumia-se a ligá-lo, fazer uma chamada e desligá-lo, mas ' +
        '       na verdade, com algum apoio da equipa clínica muito conhecedora do Addenbrooke’s ' +
        '       Hospital, adaptei-me muito bem ao smartphone e à aplicação CamAPS FX. ' +
        '       A sua capacidade de simplesmente controlar e tratar a diabetes é simplesmente extraordinária e muito libertadora.” ' +
        '    </i> ' +
        '</p> ' +
        '<h3> ' +
        '    Discrição total ' +
        '</h3> ' +
        '<p> ' +
        '    Desde que começou a utilizar a aplicação CamAPS FX, Roger reduziu o bólus ' +
        '   de insulina e viu uma redução da quantidade de insulina necessária todos os dias. ' +
        '   Mas Roger também observou outros benefícios.  ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '        “Agora, quando saímos para refeições, só preciso de tirar o smartphone, ' +
        '       introduzir a contagem de hidratos de carbono e está feito. Consigo ver os meus níveis de imediato ' +
        '       e posso fazer tudo o que preciso no telemóvel. Antes de ter a aplicação, precisava de ' +
        '       andar com agulhas e insulina e ia à casa de banho fazer uma picada no ' +
        '       dedo e as injeções necessárias. Agora, tudo isso é tratado com total discrição.” ' +
        '    </i> ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '        “Outra ocasião em que beneficiámos da aplicação foi no início da pandemia de COVID-19, ' +
        '       quando eu piorara bastante. Estava a pensar no pior, mas a aplicação estava a fornecer uma ' +
        '       leitura contínua dos meus níveis de glicose, o que foi um grande consolo. A certa altura ' +
        '       adormeci e a minha mulher receou que eu pudesse entrar em coma diabético, mas ela ' +
        '       verificou em silêncio os meus níveis de glicose no telemóvel enquanto eu dormia e viu que estava tudo bem. ' +
        '       A aplicação proporciona paz de espírito, o que é um benefício tanto para a minha qualidade de vida como para a da minha mulher.”' +
        '    </i> ' +
        '</p> ' +
        '<p> ' +
        '        A sensação de tranquilidade e discrição não é algo que apenas ' +
        '       Roger e a sua mulher tenham experienciado. A investigação demonstrou que a aplicação CamAPS ' +
        '       FX ajuda as pessoas a sentirem-se menos sobrecarregadas pela diabetes e mais capazes de ' +
        '       viver vidas flexíveis e espontâneas. ' +
        '</p> ' +
        '<p> ' +
        '        As pessoas também atribuíram à aplicação o papel de rede de segurança e um ' +
        '       nível de capacidade de resposta que ultrapassava as suas próprias capacidades. ' +
        '       Ainda assim, os utilizadores podem substituir a aplicação se pretenderem reduzir ou ' +
        '       potenciar a terapêutica devido a exigências fisiológicas como o exercício ou a doença.' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '        “É incrível o quanto o tratamento mudou desde que fui diagnosticado. ' +
        '       Sinto verdadeiramente que passei do deserto para o mundo digital. Para quem ' +
        '       esteja a considerar a aplicação CamAPS FX, o meu conselho é muito simples: avance. É realmente ' +
        '       transformadora; e, se eu consigo, qualquer pessoa consegue.” ' +
        '    </i> ' +
        '</p>'

};
/**
 * Texts for Amanda McLaren's review (list, home slider, and detail article)
 */
export const amandaReviewText = {
    title: 'Amanda McLaren - CamAPS FX',
    titleMeta: 'Leia a história de Amanda McLaren sobre o CamAPS FX na Nova Zelândia',
    descriptionMeta: 'Amanda McLaren partilha como o CamAPS FX com a YpsoPump e o FreeStyle Libre 3+, ' +
        'financiado pelo sistema público na Nova Zelândia em 2024, significou menos hipoglicemias, glicose mais estável, uma HbA1c mais baixa e mais paz de espírito após 55 anos com diabetes tipo 1.',
    keywords:
        'história camaps Amanda McLaren, história camaps fx Amanda McLaren, ' +
        '',
    localeMeta: 'pt_PT',

    imageTitle: 'Amanda McLaren',
    shortIntroAndBody:
        '<h2>Passar menos tempo a injetar é libertador.</h2>' +
        '<p>' +
        '    Aos 60 anos, Amanda McLaren vive com diabetes tipo 1 há 55 anos. ' +
        '    Começou a utilizar o CamAPS FX em outubro de 2024, com a YpsoPump e ' +
        '    o FreeStyle Libre 3+, quando esta solução passou a ser financiada pelo sistema público na Nova Zelândia. ' +
        '    Desde então, tem tido menos hipoglicemias e uma rotina diária muito mais fácil de gerir.' +
        '</p>',
    body:
        '<h2>Passar menos tempo a injetar é libertador.</h2> ' +
        '<p> ' +
        '    <strong> ' +
        '    Aos 60 anos, Amanda McLaren vive com diabetes tipo 1 há 55 anos. Começou a utilizar ' +
        '    o CamAPS FX em outubro de 2024, com a YpsoPump e o FreeStyle Libre 3+, quando esta solução passou a ser financiada pelo sistema público ' +
        '    na Nova Zelândia. Desde então, tem tido menos hipoglicemias e uma rotina diária muito mais fácil de gerir. ' +
        '    </strong> ' +
        '</p> ' +
        '<p> ' +
        '    Diagnosticada a 13 de abril de 1972, os primeiros anos de gestão da diabetes tipo 1 foram sobretudo por tentativa e erro e, ' +
        '    mesmo com a monitorização da glicose em casa, as picadas constantes no dedo deixavam-nos doridos e era comum corrigir em excesso ou ' +
        '    administrar um bólus insuficiente. Utilizar o FreeStyle Libre 2 ajudou, mas injetar até 10 vezes por dia era ' +
        '    moroso e muitas vezes complicado. ' +
        '</p> ' +
        '<p> ' +
        '    Amanda também enfrentou hipoglicemias noturnas e o fenómeno do amanhecer, que afetavam o seu sono e tornavam as manhãs esgotantes. ' +
        '    Encontrar uma forma melhor de gerir a sua condição era crucial para o bem-estar mental e físico, e para ' +
        '    reduzir o risco de complicações. ' +
        '</p> ' +
        '<p> ' +
        '    Começar a utilizar o CamAPS FX foi simples, com Amanda a dizer: ' +
        '    <i>“Tive uma excelente equipa a ajudar-me e achei fácil.”</i> ' +
        '</p> ' +
        '<p> ' +
        '    A aplicação retirou-lhe muitas decisões, com ajustes basais constantes que mantêm os seus níveis de glicose ' +
        '    mais estáveis. Explicou: ' +
        '    <i>“É necessária muito menos intervenção. Para além de introduzir as refeições, basicamente já não tenho de me preocupar.”</i> ' +
        '</p> ' +
        '<p> ' +
        '    Desde que começou a utilizar o CamAPS FX, a HbA1c de Amanda está mais baixa, as oscilações da glicose são menores, o fenómeno do amanhecer ' +
        '    desapareceu e as hipoglicemias noturnas acontecem muito menos vezes. Não ter de gerir cada pormenor da ' +
        '    diabetes tipo 1 tem sido um enorme alívio. ' +
        '</p> ' +
        '<p> ' +
        '    Amanda observou: ' +
        '    <i>“Passar menos tempo a injetar é libertador. Um melhor controlo dá-me mais paz de espírito.”</i> Agora passa ' +
        '    muito menos tempo a preocupar-se com hiperglicemias e hipoglicemias, o que lhe dá mais liberdade e confiança no dia a dia. ' +
        '</p> ' +
        '<p> ' +
        '    Refletindo sobre a sua experiência como utilizadora, Amanda concluiu: ' +
        '    <i>“Depois de um período inicial de adaptação, enquanto a aplicação ‘aprendia’ sobre mim e eu aprendia a confiar nela para ' +
        '    gerir a minha condição, muita preocupação e tomada de decisões desapareceram. É fácil de utilizar e foi ' +
        '    transformadora para mim.”</i> ' +
        '</p>',
};

/**
 * Texts for Christopher Salter's review (list, home slider, and detail article)
 */
export const christopherReviewText = {
    title: 'Christopher Salter - CamAPS FX',
    titleMeta: 'Leia a história de Christopher Salter sobre o CamAPS FX',
    descriptionMeta: 'Christopher Salter partilha como o CamAPS FX com a YpsoPump e o FreeStyle Libre 3 Plus ' +
        'melhorou o tempo no intervalo-alvo, a HbA1c e a vida diária após mais de três décadas com diabetes tipo 1.',
    keywords:
        'história camaps Christopher Salter, história camaps fx Christopher Salter, ' +
        '',
    localeMeta: 'pt_PT',

    imageTitle: 'Christopher Salter',
    shortIntroAndBody:
        '<h2>É o mais próximo que consigo imaginar da sensação de não ter diabetes</h2>' +
        '<p>' +
        '    Para Christopher Salter, viver com diabetes tipo 1 tem sido uma experiência ao longo de toda a vida, que moldou grande parte ' +
        '    do seu quotidiano desde que foi diagnosticado com apenas dois anos. Agora, aos 36 anos, passou mais de três décadas ' +
        '    a lidar com os desafios de uma condição frequentemente imprevisível e exigente.' +
        '</p>',
    body:
        '<h2>É o mais próximo que consigo imaginar da sensação de não ter diabetes</h2> ' +
        '<p> ' +
        '    <strong> ' +
        '    Para Christopher Salter, viver com diabetes tipo 1 tem sido uma experiência ao longo de toda a vida, que moldou grande parte ' +
        '    do seu quotidiano desde que foi diagnosticado com apenas dois anos. Agora, aos 36 anos, passou mais de três décadas ' +
        '    a lidar com os desafios de uma condição frequentemente imprevisível e exigente. ' +
        '    </strong> ' +
        '</p> ' +
        '<p> ' +
        '    Os seus níveis de glicose eram frequentemente difíceis de estabilizar, e os episódios regulares de hipoglicemia tornavam a vida diária ' +
        '    stressante e esgotante. Antes de utilizar tecnologia avançada, Chris descreve a gestão da diabetes tipo 1 ' +
        '    como <i>“muito stressante e morosa”</i>, com grande parte da sua energia focada em prevenir ' +
        '    e tratar hipoglicemias. ' +
        '</p> ' +
        '<p> ' +
        '    Estes desafios iam para além da saúde física. Na escola, os episódios eram frequentemente tratados à frente dos ' +
        '    colegas, o que o fazia sentir-se exposto, enquanto nos anos seguintes lhe era difícil explicar a sua condição aos ' +
        '    outros, o que afetou as suas relações e a confiança. Com o tempo, a pressão constante conduziu a esgotamento ' +
        '    e a um crescente distanciamento dos cuidados da diabetes tipo 1. ' +
        '</p> ' +
        '<p> ' +
        '    Depois de concluir um curso DAFNE, a enfermeira especialista em diabetes de Chris recomendou o CamAPS FX como forma de ' +
        '    aliviar o impacto da gestão diária. Começou a utilizar o sistema há cerca de três anos, em conjunto com a ' +
        '    YpsoPump e o FreeStyle Libre 3 Plus. Embora o acesso ao financiamento tenha exigido paciência, considerou o ' +
        '    processo de formação e configuração simples assim que tudo esteve em vigor. ' +
        '</p> ' +
        '<p> ' +
        '    O impacto tem sido significativo. Desde que começou a utilizar o CamAPS FX, Chris observou melhorias notáveis no ' +
        '    tempo no intervalo-alvo, na HbA1c e na estabilidade geral da glicose. Os episódios de hipoglicemia – especialmente durante a noite e ' +
        '    no trabalho – reduziram-se consideravelmente, e a qualidade do sono melhorou em consequência. ' +
        '</p> ' +
        '<p> ' +
        '    Mais importante, o sistema mudou a forma como se sente no dia a dia. Com menos necessidade de ' +
        '    tomada de decisões constante, sente-se mais relaxado e no controlo, e o peso mental de gerir a diabetes tipo 1 ' +
        '    diminuiu. Chris disse: ' +
        '    <i>“Utilizar o CamAPS FX tem sido, até à data, o mais próximo de não ter diabetes, pois é o mais próximo que consigo ' +
        '    imaginar da sensação de não ter diabetes.”</i> ' +
        '</p> ' +
        '<p> ' +
        '    Chris continua a utilizar o CamAPS FX e considera-o uma parte essencial dos seus cuidados a longo prazo. Recomendá-lo-ia de bom grado ' +
        '    a outras pessoas, citando não só as melhorias clínicas, mas também o sentido renovado de normalidade e ' +
        '    confiança que trouxe à sua vida. ' +
        '</p>',
};


/**
 * Texts for Alice Hibbert-Davies review article
 */
export const aliceReviewText = {
    title: 'Alice Hibbert-Davies - CamAPS FX',
    titleMeta: 'Read Alice Hibbert-Davies\' review of CamAPS FX',
    descriptionMeta: 'Alice Hibbert-Davies shares how the myLoop system with CamAPS FX transformed her type 1 diabetes ' +
        'management and helped her conquer Mount Kilimanjaro.',
    keywords:
        'camaps review Alice Hibbert-Davies, camaps fx review Alice Hibbert-Davies, myLoop CamAPS FX, ' +
        '',
    localeMeta: 'en_gb',

    imageTitle: 'Alice Hibbert-Davies',
    shortIntroAndBody:
        '<h2>From managing T1D to conquering Mount Kilimanjaro.</h2>' +
        '<p>' +
        '    Alice Hibbert-Davies is reaching new heights with the help of the myLoop system with CamAPS FX, which she ' +
        '    credits with transforming her diabetes management and giving her greater freedom to embrace life\'s ' +
        '    biggest adventures.' +
        '</p>',
    body:
        '<h2>From managing type 1 diabetes to conquering the summit of Mount Kilimanjaro.</h2> ' +
        '<p> ' +
        '    <strong> ' +
        '    Alice Hibbert-Davies is reaching new heights with the help of the myLoop system with CamAPS FX, which she ' +
        '    credits with transforming her diabetes management and giving her greater freedom to embrace life\'s ' +
        '    biggest adventures. ' +
        '    </strong> ' +
        '</p> ' +
        '<p> ' +
        '    Alice was diagnosed with type 1 diabetes when she was 18 after experiencing symptoms including increased ' +
        '    thirst, weight loss and passing urine more frequently. She was already familiar with the condition as her ' +
        '    younger sister had been diagnosed with type 1 diabetes a few years earlier at the age of 13. ' +
        '</p> ' +
        '<p> ' +
        '    Alice quickly contacted her doctor with the suspicion she had type 1 diabetes but despite her prior ' +
        '    knowledge and experience of the condition, she said it still came as a shock when she was diagnosed. ' +
        '</p> ' +
        '<p> ' +
        '    Alice said: ' +
        '    <i>“Even though I thought I had type 1 diabetes, when I was told I still thought, ‘Oh my gosh, why has ' +
        '    this happened to me?’</i> ' +
        '</p> ' +
        '<p> ' +
        '    <i>“It was still a massive shock and difficult to take in all the information – I found it overwhelming.”</i> ' +
        '</p> ' +
        '<p> ' +
        '    Alice was in her first year of studying for a degree in wildlife conservation but was living at home, ' +
        '    which she said made it a little easier for her to navigate the early days following her diagnosis. ' +
        '</p> ' +
        '<p> ' +
        '    <i>“To begin with, it was a massive change to how I live and trying to work out how managing my diabetes ' +
        '    would fit into my life – all the decision making and checking my levels,”</i> Alice said. ' +
        '</p> ' +
        '<p> ' +
        '    For the first year following her diagnosis, Alice manually injected insulin but jumped at the chance of ' +
        '    using a closed-loop system when it was offered to her. ' +
        '</p> ' +
        '<p> ' +
        '    Alice, who is 22 and lives in Bath, said opting for the closed loop system was ' +
        '    <i>“one of the best decisions I have ever made”</i>. ' +
        '</p> ' +
        '<p> ' +
        '    She said: ' +
        '    <i>“I was drawn to the YpsoPump with CamAPS FX because of the flexibility it gives me. I’d heard from ' +
        '    other people how much easier it made managing their condition. The main draw was the pre-filled insulin ' +
        '    vials and how it is approved for use in pregnancy, which is good to know for the future.”</i> ' +
        '</p> ' +
        '<p> ' +
        '    A part-time gymnastics coach and regular hiker, Alice said she is grateful for CamAPS for allowing her ' +
        '    to continue to pursue an active lifestyle. ' +
        '</p> ' +
        '<p> ' +
        '    <i>“CamAPS is very straightforward to use in terms of inputting things like carbs and hypo snacks,”</i> ' +
        '    she said. ' +
        '</p> ' +
        '<p> ' +
        '    <i>“I’m always impressed by it. I have a very busy lifestyle and my daily routine is different every day ' +
        '    of the week, but it always manages to keep my level in range, even when I’m waking up at different times ' +
        '    and eating meals at different times of the day.</i> ' +
        '</p> ' +
        '<p> ' +
        '    <i>“It’s that peace of mind, knowing it’s working and keeping me in range. It just takes away some of ' +
        '    the extra stress of having diabetes.”</i> ' +
        '</p> ' +
        '<p> ' +
        '    Alice, who is currently studying for a PhD in herpetology, the study of reptiles and amphibians, climbed ' +
        '    Mount Kilimanjaro in September 2026, using the challenge to raise awareness of type 1 diabetes and inspire ' +
        '    others who have been diagnosed. ' +
        '</p> ' +
        '<p> ' +
        '    She said: ' +
        '    <i>“Having type 1 diabetes doesn’t have to stop you. You can still live the life you want.”</i> ' +
        '</p>',
};
